import Page from '../../../../components/organisms/Page'

export default Page
